import { z } from 'zod';
export const PercentageSchema = z.number();
export const PercentagePointsSchema = z.number();
export const AreaUnitSchema = z.enum(['sqm', 'living_space']);
export const AreaValueSchema = z.object({
    value: z.number(),
    unit: AreaUnitSchema,
});
